import { IMAGE_PANORAMA_720_CONFIG } from '../../config/postTask.config';
import type { ImageNodeNineGridTemplate } from './types';

export const IMAGE_PANORAMA_TEMPLATE_ID = 'panorama_720';
export const IMAGE_PANORAMA_TOOL_LABEL = '720°全景';
export const IMAGE_PANORAMA_PANEL_SIZE = { width: 444, height: 342 };
/** 生成结果固定为 2:1 等距柱状图，节点保持同宽高比可避免 contain 留黑边。 */
export const IMAGE_PANORAMA_RESULT_DISPLAY_SIZE = { width: 408, height: 204 };
export const IMAGE_PANORAMA_PREVIEW_DISPLAY_SIZE = { width: 1008, height: 591 };

export const IMAGE_PANORAMA_TEMPLATE: ImageNodeNineGridTemplate = {
  id: IMAGE_PANORAMA_TEMPLATE_ID,
  label: IMAGE_PANORAMA_720_CONFIG.nodeName,
  labelKey: IMAGE_PANORAMA_720_CONFIG.nodeNameKey,
  apiName: IMAGE_PANORAMA_720_CONFIG.api_name,
  inputParameterKey: 'image_list',
  parameters: IMAGE_PANORAMA_720_CONFIG.parameters,
};

export const IMAGE_PANORAMA_RESOLUTION_OPTIONS = ['1K', '2K', '4K'] as const;
